import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";

import Brandschilderen from "./views/brandschilderen";
import Historie from "./views/historie";
import Contact from "./views/contact";
import GlasInLood from "./views/glas-in-lood";
import Glaszetten from "./views/glaszetten";
import Fusing from "./views/fusing";
import Home from "./views/home";
import Diensten from "./views/diensten";
import TeKoop from "./views/te-koop";
import GestraaldGlas from "./views/gestraald-glas";
import NotFound from "./views/not-found";
import "./style.css";

Vue.use(Router);
Vue.use(Meta);
export default new Router({
  mode: "history",
  routes: [
    {
      name: "Brandschilderen",
      path: "/brandschilderen",
      component: Brandschilderen,
    },
    {
      name: "Historie",
      path: "/historie",
      component: Historie,
    },
    {
      name: "Contact",
      path: "/contact",
      component: Contact,
    },
    {
      name: "Glas-in-lood",
      path: "/glas-in-lood",
      component: GlasInLood,
    },
    {
      name: "Glaszetten",
      path: "/glaszetten",
      component: Glaszetten,
    },
    {
      name: "Fusing",
      path: "/fusing",
      component: Fusing,
    },
    {
      name: "Home",
      path: "/",
      component: Home,
    },
    {
      name: "Diensten",
      path: "/diensten",
      component: Diensten,
    },
    {
      name: "Te Koop",
      path: "/te-koop",
      component: TeKoop,
    },
    {
      name: "Gestraald Glas",
      path: "/gestraald-glas",
      component: GestraaldGlas,
    },
    {
      name: "404 - Not Found",
      path: "**",
      component: NotFound,
      fallback: true,
    },
  ],
});
